import React from "react";
import { useTranslation } from "react-i18next";

interface RecommendationItemProps {
    apiName: string;
    label: any;
    doneEnhancements: string;
    loadingItem: boolean;
    isApplying: boolean;
    onClick: (apiName: string) => void;
    svg: React.ReactNode;
    enhancementStatus: string
}

const RecommendationItem: React.FC<RecommendationItemProps> = ({
    apiName,
    label,
    doneEnhancements,
    loadingItem,
    isApplying,
    onClick,
    svg,
    enhancementStatus
}) => {
    const { t } = useTranslation();


    return (

        <li className={`mb-3 back-color-home back-reco ${enhancementStatus == "Done" ? "back-done" : ""}`} key={label?.name || apiName}>
            <div className="d-flex align-items-center">
                {svg}
                <h5 className="para-16 color-black marg-left-10 bold-500">{label?.name ? t(`enhancementList.${label.name}`) : apiName}</h5>
            </div>
            <div className="d-flex align-items-center justify-content-end">
                {enhancementStatus == "Done" ?
                    <span className={`badge border-trans bg-label-success-trans`}>
                        <svg width="20" height="20" className="marg-right-10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_715_435)">
                                <path d="M14.1665 2.78333C15.4234 3.50905 16.469 4.55044 17.1997 5.80442C17.9304 7.05839 18.321 8.48148 18.3327 9.93278C18.3444 11.3841 17.9769 12.8133 17.2665 14.0789C16.5561 15.3445 15.5275 16.4027 14.2825 17.1486C13.0375 17.8945 11.6193 18.3024 10.1683 18.3317C8.7172 18.3611 7.28363 18.011 6.00947 17.316C4.7353 16.6211 3.66473 15.6054 2.90373 14.3696C2.14272 13.1338 1.71768 11.7206 1.67067 10.27L1.6665 10L1.67067 9.73C1.71734 8.29082 2.13613 6.8883 2.8862 5.65916C3.63628 4.43002 4.69205 3.41621 5.95058 2.71657C7.20911 2.01693 8.62746 1.65533 10.0673 1.66703C11.5072 1.67873 12.9195 2.06333 14.1665 2.78333ZM13.089 7.74417C12.9455 7.60069 12.7546 7.51449 12.5521 7.50176C12.3496 7.48902 12.1493 7.55062 11.989 7.675L11.9107 7.74417L9.1665 10.4875L8.089 9.41083L8.01067 9.34167C7.85033 9.21738 7.65015 9.15585 7.44768 9.16863C7.2452 9.1814 7.05434 9.2676 6.91089 9.41105C6.76744 9.55451 6.68124 9.74536 6.66847 9.94784C6.65569 10.1503 6.71722 10.3505 6.8415 10.5108L6.91067 10.5892L8.57734 12.2558L8.65567 12.325C8.80182 12.4384 8.98153 12.4999 9.1665 12.4999C9.35148 12.4999 9.53119 12.4384 9.67734 12.325L9.75567 12.2558L13.089 8.9225L13.1582 8.84417C13.2825 8.68383 13.3441 8.48362 13.3314 8.2811C13.3187 8.07858 13.2325 7.88766 13.089 7.74417Z" fill="#22C55E" />
                            </g>
                            <defs>
                                <clipPath id="clip0_715_435">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg> {t(`enhancementList.${enhancementStatus}`)} </span>

                    : <button className={`badge border-trans cursor-p ${isApplying ? "disabled" : ""} ${enhancementStatus == "Nice to have"
                        ? "bg-label-warning" : (enhancementStatus == "Good"
                            ? "bg-label-6366F1" : "bg-label-danger")} 
                                     ${(doneEnhancements == "Done") ? "disabled" : ''}`} onClick={() => onClick(apiName)}>
                        {t(`enhancementList.${enhancementStatus}`)}
                    </button>
                }

                {label?.popUp && <svg width="16" height="16" className="marg-right-5 marg-left-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.33349 1.33337H4.00016C2.5275 1.33337 1.3335 2.52737 1.3335 4.00004V12C1.3335 13.4727 2.5275 14.6667 4.00016 14.6667H12.0002C13.4728 14.6667 14.6668 13.4727 14.6668 12C14.6668 10.486 14.6668 8.66671 14.6668 8.66671C14.6668 8.29871 14.3682 8.00004 14.0002 8.00004C13.6322 8.00004 13.3335 8.29871 13.3335 8.66671V12C13.3335 12.736 12.7362 13.3334 12.0002 13.3334C9.78016 13.3334 6.21949 13.3334 4.00016 13.3334C3.2635 13.3334 2.66683 12.736 2.66683 12C2.66683 9.78004 2.66683 6.21937 2.66683 4.00004C2.66683 3.26337 3.2635 2.66671 4.00016 2.66671H7.33349C7.70149 2.66671 8.00016 2.36804 8.00016 2.00004C8.00016 1.63204 7.70149 1.33337 7.33349 1.33337ZM12.3908 2.66671H10.0002C9.63216 2.66671 9.33349 2.36804 9.33349 2.00004C9.33349 1.63204 9.63216 1.33337 10.0002 1.33337H14.0002C14.3682 1.33337 14.6668 1.63204 14.6668 2.00004V6.00004C14.6668 6.36804 14.3682 6.66671 14.0002 6.66671C13.6322 6.66671 13.3335 6.36804 13.3335 6.00004V3.60937L8.47149 8.47137C8.21149 8.73137 7.78883 8.73137 7.52883 8.47137C7.26816 8.21137 7.26816 7.78871 7.52883 7.52871L12.3908 2.66671Z" fill="black" />
                </svg>}

                {loadingItem && (
                    <div className="col-auto marg-left-5">
                        <div className="spinner-border text-primary size-20" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>
        </li>
    );
};

export default RecommendationItem;
